import type { CountryCode } from 'libphonenumber-js';

/**
 * @description The backend is sending a UK code instead of a GB code
 * @param countryKey
 * @returns CountryCode
 */
export const handleUnitedKingdomException = (countryKey: string) => {
  if (countryKey === 'UK') {
    return 'GB';
  }
  return countryKey as CountryCode;
};
